import React from "react";
import PropTypes from "prop-types";

import AfricaMap from "../map";
import KeyNumbersGraphic from "./KeyNumbersGraphic";

const Highcharts = window.Highcharts;

const KeyNumbers = ({ mapOptions, selectedCountry, data, icons, currentTab }) => (
  <div>
    <section className="key-numbers">
      <div className="map-wrapper">
        <div className="map-help">
          Discover country specific data, including key numbers, tariffs and information on financing. Select countries from the map or dropdown menu and toggle between tabs at the top.
          <div className="border" />
        </div>
        <AfricaMap
          options={mapOptions}
          highcharts={Highcharts}
          selectedCountry={selectedCountry}
          currentTab={currentTab}
        />
      </div>
      <div className="chart-wrapper">
        {selectedCountry && selectedCountry !== "all" && <KeyNumbersGraphic data={data} icons={icons} />}
      </div>
    </section>
  </div>
);

export default KeyNumbers;

KeyNumbers.propTypes = {
  currentTab: PropTypes.string.isRequired,
  data: PropTypes.shape({}).isRequired,
  icons: PropTypes.shape({}).isRequired,
  mapOptions: PropTypes.shape({}).isRequired,
  selectedCountry: PropTypes.string.isRequired,
};
